<template>
  <div class="form-area">
    <div class="form-title">
      如因提交錯誤個人資料以致申請失敗，本會恕不負責，請小心填寫</br>
      If the application fails due to the submission of the wrong personal data, we will not be</br> responsible for it.
      Please fill out carefully
    </div>

    <div class="form-header-desc" style="font-weight:500">
      查詢申請時，你需要輸入申請編號及電郵地址。如果你輸入的資料與紀錄相符，系統會顯示你的申請狀況。</br>Please enter the application number and your email. If the
      information matches records, the application status will be shown.
    </div>
    <el-form :model="condictionForm" :rules="condictionFormRules" ref="condictionForm">
      <el-row class="form-row">
        <el-col :span="4">
          <div class="form-label">申請編號 *</br> Application ID</div>
        </el-col>
        <el-col :span="10">
          <div class="form-input">
            <el-form-item prop="applicationId">
              <el-input placeholder="Ex:TPH24000702" v-model="condictionForm.applicationId"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row class="form-row">
        <el-col :span="4">
          <div class="form-label">電郵地址 *</br> Email</div>
        </el-col>
        <el-col :span="10">
          <div class="form-input">
            <el-form-item prop="verifyEmail">
              <el-input placeholder="Ex: myname@example.com" v-model="condictionForm.verifyEmail"></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>


    <div class="btn-box">
      <el-col :span="4"></el-col>
      <el-button class="next-btn" type="warning" round @click="nextSetp">下一步 Next</el-button>
    </div>
  </div>
</template>

<script>
  import {
    sendQueryVerifyMail
  } from "@/assets/js/api.js";
  import {
    validateEmail
  } from "@/utils/json/utils";
  export default {
    data() {
      return {
        condictionForm: {},
        condictionFormRules: {
          applicationId: [{
            required: true,
            trigger: "blur",
            message: " "
          }, ],
          verifyEmail: [{
            required: true,
            trigger: "blur",
            message: " "
          }],
        },
      };
    },
    methods: {
      nextSetp() {
        this.$refs.condictionForm.validate((valid) => {
          if (valid) {
            if (!validateEmail(this.condictionForm.verifyEmail)) {
              this.$message.warning(
                "請輸入正確格式的電郵地址 Please Enter Correct format Email!"
              );
              return;
            }
            this.Session.set("queryParams", this.condictionForm); //将查询条件放入缓存
            this.sendEmailCode();
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      sendEmailCode() {
        sendQueryVerifyMail(this.condictionForm).then(
          (res) => {
            this.$message.success("驗證碼經已發出，請查閱電子郵箱。");
            this.$store.dispatch("NEXT_STEP", {
              changeStep: false,
              operateName: "emailVerify",
            });
          }
        );
      },
    },
  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/query/child/condiction.vue